import { useSyncExternalStore } from 'react';

/**
 * Como a Nova evolução mostra os módulos (spec 026) — da pessoa (segue a
 * conta, `prefsNaConta`):
 *   - 'cartoes' (padrão): como sempre, um cartão por módulo;
 *   - 'linhas': sem cartões, uma linha de 1 px entre os módulos;
 *   - 'abas': uma etapa da consulta por vez, com o resumo à esquerda.
 * Escolhe em Configurações › Tela de Atendimento; com 'linhas' ou 'abas', a
 * troca Linhas | Abas aparece na barra do editor e grava a mesma chave.
 */
export type EvolucaoVisual = 'cartoes' | 'linhas' | 'abas';

export const EVOLUCAO_VISUAL_KEY = 'dratento.ficha.evolucao.v1';

const CHANGE_EVENT = 'dratento:evolucao-visual';

const read = (): EvolucaoVisual => {
  try {
    const v = localStorage.getItem(EVOLUCAO_VISUAL_KEY);
    return v === 'linhas' || v === 'abas' ? v : 'cartoes';
  } catch {
    return 'cartoes';
  }
};

const subscribe = (cb: () => void) => {
  window.addEventListener(CHANGE_EVENT, cb);
  window.addEventListener('storage', cb);
  return () => {
    window.removeEventListener(CHANGE_EVENT, cb);
    window.removeEventListener('storage', cb);
  };
};

/** Lê ao vivo: trocar nas Configurações ou na barra atualiza na hora. */
export const useEvolucaoVisual = (): EvolucaoVisual =>
  useSyncExternalStore(subscribe, read, () => 'cartoes');

/**
 * Fase 3 (barras enxutas): com Linhas ou Abas o <html> ganha
 * `data-evolucao`, e `src/styles/evolucao-enxuta.css` tira molduras e
 * paddings em volta da ficha — o mesmo jeito do visual Google.
 */
export const applyEvolucaoVisual = (v: EvolucaoVisual = read()) => {
  if (v === 'cartoes') document.documentElement.removeAttribute('data-evolucao');
  else document.documentElement.setAttribute('data-evolucao', v);
};

export const setEvolucaoVisual = (v: EvolucaoVisual) => {
  try {
    // O padrão não grava: quem nunca escolheu fica sem a chave.
    if (v === 'cartoes') localStorage.removeItem(EVOLUCAO_VISUAL_KEY);
    else localStorage.setItem(EVOLUCAO_VISUAL_KEY, v);
  } catch {
    /* sem storage: fica como está */
  }
  applyEvolucaoVisual(v);
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

// Outra aba (ou a conta, via prefsNaConta) trocou: o atributo acompanha.
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === EVOLUCAO_VISUAL_KEY || e.key === null) applyEvolucaoVisual();
  });
}
